export default function removeTrailingSlash(url) {
    return url.replace(/\/$/, "");
}
